import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
   components: {
      ASpaceInBetweenAnother
   }
})
export default class OpenhouseCard extends Vue {
   public title: string = 'OpenhouseCard';

   @Prop()
   public data: any;

   public displayData: any = {};

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      this.displayData = val;
      this.displayData.openDesc = this.decodeOpenHouse(this.displayData.openhouse);
   }

   public decodeOpenHouse(openhouse: string) {
      if (openhouse.length > 1) {
         const splitedOne = openhouse[0].split(' ');
         const splitedTwo = openhouse[1].split(' ');
         return `${splitedOne[0]}/${splitedTwo[0]} ${splitedOne[4]}${splitedOne[5]} - ${splitedOne[7]}${splitedOne[8]}`;
      } else {
         const splitedOne = openhouse[0].split(' ');
         return `${splitedOne[0]} ${splitedOne[4]}${splitedOne[5]} - ${splitedOne[7]}${splitedOne[8]}`;
      }
   }

   public navToDetail(mlsNumber: string) {
      // this.$router.push(`/listing/treb-${mlsNumber}`);
   }
}
